// String constants and messages
export const STRING_CONSTANTS = {
  BUTTONS: {
    ADD_PATIENT: 'Add Patient',
    EDIT: 'Edit',
    DELETE: 'Delete',
    SAVE: 'Save',
    CANCEL: 'Cancel',
    SEARCH: 'Search',
    CLEAR: 'Clear',
    VIEW_ALL: 'View All',
    VIEW_REPORT: 'View Appointment Report',
    /* B603 — patient → completed appointment details has a "View
     * Prescription" button that referenced this key as undefined. */
    VIEW_PRESCRIPTION: 'View Prescription',
    SUBMIT: 'Submit',
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    RETRY: 'Try again',
    FORGOT_PASSWORD: 'Forgot Password?',
    TOGGLE_PASSWORD_VISIBILITY: 'Toggle password visibility',
    BACK_TO_APPOINTMENTS: 'Back to Appointments',
    CANCEL_APPOINTMENT: 'Cancel Appointment',
    NEW_APPOINTMENT: 'New Appointment',
    MARK_COMPLETE: 'Mark as Complete',
    RESCHEDULE: 'Reschedule',
    START_APPOINTMENT: 'Start Appointment',
    ADD_NOTES: 'Add Notes',
    VIEW_MEDICAL_RECORDS: 'View Medical Records',
    CREATE_PRESCRIPTION: 'Create Prescription',
    ORDER_LAB_TESTS: 'Order Lab Tests',
    UPDATE_VITALS: 'Update Vitals',
    SAVE_NOTES: 'Save Notes',
    SAVE_MEDICATION: 'Save Medication',
    PRINT: 'Print',
    EXPORT_PDF: 'Export PDF',
    BACK: 'Back',
    SEND_EMAIL: 'Send Email',
    NEW_INVOICE: 'New Invoice',
    VIEW: 'View',
    SCHEDULE_APPOINTMENT: 'Schedule Appointment',
    EDIT_PATIENT: 'Edit Patient',
    CLOSE: 'Close',
    DEV_ADD_PATIENT_ONE: 'Add Dev Patient A',
    DEV_ADD_PATIENT_TWO: 'Add Dev Patient B',
    DEV_ADD_PATIENT_THREE: 'Add Dev Patient C',
    DEV_QUICK_FILL: 'Dev Quick Fill',
    DEV_FILL_ALL: 'Dev Fill All',
    CREATE_APPOINTMENT: 'Create Appointment',
    UPDATE: 'Update',
    ADD_TEST: 'Add Test',
    ADD_SYMPTOM: 'Add Symptom',
    GENERATE_INVOICE: 'Generate Invoice',
    CREATE_INVOICE: 'Create Invoice',
    ADD_CUSTOM_ITEM: '+ Add Custom Item',
    DEV_QUICK_LOGIN: '\u{1F680} Quick Login (Dev Only)',
    DEV_NOTICE: '\u{1F4A1} Development Mode - You can use the quick login button above or test with:',
    REGISTER: 'Create Account',
    BACK_TO_SIGN_IN: 'Back to Sign In',
    COMPLETE_PROFILE: 'Complete Registration',
    SIGN_IN_GOOGLE: 'Continue with Google',
    TRY_AGAIN: 'Try Again',
    GO_BACK: 'Go Back',
    MARK_ALL_READ: 'Mark all as read',
    MESSAGE_DOCTOR: 'Message Doctor',
    LEAVE_REVIEW: 'Leave Review',
    BOOK: 'Book Appointment',
    UPLOAD: 'Upload',
    REQUEST_CHANGE: 'Request Change',
    WITHDRAW_REQUEST: 'Withdraw',
    SAVE_PROFILE: 'Save Changes',
    SUBMIT_REVIEW: 'Submit Review',
    APPROVE: 'Approve',
    REJECT: 'Reject',
    DOWNLOAD: 'Download',
    SEND: 'Send',
    ATTACH_FILE: 'Attach file',
    SHOW_HISTORY: 'Show history',
    HIDE_HISTORY: 'Hide history',
  },
  LABELS: {
    LOADING: 'Loading...',
    MEDICINE_NAME: 'Medicine Name',
    DOSAGE: 'Dosage',
    FREQUENCY: 'Frequency',
    TIMING: 'Timing',
    DURATION_LABEL: 'Duration',
    TEST_NAME_REQUIRED: 'Test Name *',
    SYMPTOM_NAME_REQUIRED: 'Symptom Name *',
    GENERAL_ADVICE: 'General Advice',
    FOLLOW_UP_DATE: 'Follow-up Date',
    ADD_NEW_PATIENT: 'Add New Patient',
    START_NEW_APPOINTMENT: 'Start a New Appointment',
    SUCCESS: 'Success',
    ERROR: 'Error',
    DASHBOARD: 'Dashboard',
    PATIENTS: 'Patients',
    PATIENT_RECORDS: 'Patient Records',
    RECENT_PATIENTS: 'Recent Patients',
    TOTAL_PATIENTS: 'Total Patients',
    APPOINTMENTS_TODAY: 'Appointments Today',
    TODAY_SCHEDULE: "Today's Schedule",
    APPOINTMENTS: 'Appointments',
    PENDING_TASKS: 'Pending Tasks',
    UPCOMING_APPOINTMENTS: 'Upcoming Appointments',
    PATIENT_NAME: 'Patient Name',
    TIME: 'Time',
    STATUS: 'Status',
    ADD_MEDICAL_NOTE: 'Add Medical Note',
    VIEW_ALL_PATIENTS: 'View All Patients',
    NOTIFICATIONS: 'Notifications',
    MESSAGES: 'Messages',
    SEARCH_RESULTS: 'Search Results',
    PROFILE: 'Profile',
    NEW_APPOINTMENT: 'New Appointment',
    NEW_INVOICE: 'New Invoice',
    CONSULTATION: 'Consultation',
    DURATION_30_MIN: '30 min',
    MINUTES_SHORT: 'min',
    EMAIL: 'Email',
    EMAIL_ADDRESS: 'Email Address',
    PASSWORD: 'Password',
    WELCOME_BACK: 'Welcome Back',
    LOGIN_TO_CONTINUE: 'Sign in to your account',
    APP_NAME: 'DocX',
    REMEMBER_ME: 'Remember me',
    CREATE_ACCOUNT: 'Create Account',
    REGISTER_SUBTITLE: 'Register as a new doctor',
    FULL_NAME: 'Full Name',
    CONFIRM_PASSWORD: 'Confirm Password',
    PHONE_NUMBER: 'Phone Number',
    SPECIALIZATION: 'Specialization',
    LICENSE_NUMBER: 'License Number',
    GENDER: 'Gender',
    ALREADY_HAVE_ACCOUNT: 'Already have an account?',
    DONT_HAVE_ACCOUNT: "Don't have an account?",
    SIGN_IN: 'Sign In',
    OR_CONTINUE_WITH: 'Or continue with',
    SIGN_IN_WITH_GOOGLE: 'Sign in with Google',
    COMPLETE_YOUR_PROFILE: 'Complete Your Profile',
    COMPLETE_PROFILE_SUBTITLE: 'Please provide your professional details to finish registration',
    COMPLETE_PROFILE_SUBTITLE_PATIENT: 'Add a few details to finish setting up your account',
    HELP: 'Help',
    PRIVACY: 'Privacy',
    TERMS: 'Terms',
    COPYRIGHT: '© 2026 DocX. All rights reserved.',
    APPOINTMENT_DETAILS: 'Appointment Details',
    APPOINTMENT_DETAILS_SUBTITLE: 'View and manage appointment information',
    PATIENT_INFORMATION: 'Patient Information',
    PATIENT_DETAILS: 'Patient Details',
    PATIENT_ID: 'Patient ID',
    AGE_GENDER: 'Age / Gender',
    CONTACT: 'Contact',
    BLOOD_TYPE: 'Blood Type',
    APPOINTMENT_TYPE: 'Appointment Type',
    DATE: 'Date',
    DURATION: 'Duration',
    SYMPTOM_DURATION: 'Symptom duration',
    ROOM: 'Room',
    CHIEF_COMPLAINT: 'Chief Complaint',
    SYMPTOMS: 'Symptoms',
    MEDICAL_HISTORY_SUMMARY: 'Medical History Summary',
    PREVIOUS_CONDITIONS: 'Previous Conditions',
    CURRENT_MEDICATIONS: 'Current Medications',
    ALLERGIES: 'Allergies',
    APPOINTMENT_NOTES: 'Appointment Notes',
    QUICK_ACTIONS: 'Quick Actions',
    RECENT_VITALS: 'Recent Vitals',
    HEART_RATE: 'Heart Rate',
    BLOOD_PRESSURE: 'Blood Pressure',
    TEMPERATURE: 'Temperature',
    WEIGHT: 'Weight',
    REMINDER: 'Reminder',
    PREVIOUS_APPOINTMENTS: 'Previous Appointments',
    PREVIOUS_TESTS: 'Previous Tests',
    CONSULTATION_SESSION: 'Consultation Session',
    DIAGNOSIS: 'Diagnosis',
    PRESCRIPTION: 'Prescription',
    LAB_TESTS: 'Lab Tests',
    FOLLOW_UP: 'Follow Up',
    RESPIRATORY_RATE: 'Respiratory Rate',
    OXYGEN_SATURATION: 'Oxygen Saturation',
    COMPLETE_CONSULTATION: 'Complete Consultation',
    CONSULTATION_NOTES: 'Consultation Notes',
    IN_PROGRESS: 'In Progress',
    QUICK_ADD: 'Quick Add',
    ADDED_SYMPTOMS: 'Added Symptoms',
    ADD_CUSTOM_SYMPTOM: 'Add Custom Symptom',
    TEMPLATES: 'Templates',
    MEDICATIONS: 'Medications',
    ADD_MEDICATION: 'Add Medication',
    ORDERED_TESTS: 'Ordered Tests',
    ADD_CUSTOM_TEST: 'Add Custom Test',
    TAB_PATIENT_VITALS: 'Patient Info & Vitals',
    TAB_SYMPTOMS_DIAGNOSIS: 'Symptoms & Diagnosis',
    TAB_TREATMENT_PLAN: 'Treatment Plan',
    TAB_FOLLOW_UP: 'Follow Up & Notes',
    APPOINTMENT_REPORT: 'Appointment Report',
    TEST_REPORT: 'Test Report',
    VITAL_SIGNS: 'Vital Signs',
    DIAGNOSIS_ASSESSMENT: 'Diagnosis & Assessment',
    PRESCRIBED_MEDICATIONS: 'Prescribed Medications',
    LAB_TESTS_ORDERED: 'Lab Tests Ordered',
    DOCTORS_NOTES: "Doctor's Notes",
    FOLLOW_UP_TITLE: 'Follow-up',
    INVOICE: 'INVOICE',
    BILL_TO: 'Bill To:',
    APPOINTMENT_LABEL: 'Appointment:',
    PERSONAL_INFORMATION: 'Personal Information',
    CONTACT_INFORMATION: 'Contact Information',
    EMERGENCY_CONTACT_LABEL: 'Emergency Contact',
    KNOWN_ALLERGIES: 'Known Allergies',
    FAMILY_HISTORY: 'Family History',
    PAST_SURGERIES: 'Past Surgeries',
    LIFESTYLE_HABITS: 'Lifestyle & Habits',
    MALE: 'Male',
    FEMALE: 'Female',
    DOCTOR_NAME: 'Dr. Sarah Johnson',
    NO_DIAGNOSIS: 'No diagnosis recorded',
    NO_NOTES: 'No notes available',
    NO_FOLLOW_UP: 'No follow-up scheduled',
    ID_PREFIX: 'ID:',
    AT: 'at',
    NAME_LABEL: 'Name:',
    AGE_LABEL: 'Age:',
    GENDER_LABEL: 'Gender:',
    TYPE: 'Type',
    TYPE_LABEL: 'Type:',
    DOCTOR_LABEL: 'Doctor:',
    MEDICATION_HEADER: 'Medication',
    DOSAGE_HEADER: 'Dosage',
    FREQUENCY_HEADER: 'Frequency',
    TIMING_HEADER: 'Timing',
    DURATION_HEADER: 'Duration',
    NEXT_APPOINTMENT_RECOMMENDED: 'Next appointment recommended on:',
    ATTENDING_PHYSICIAN: 'Attending Physician:',
    REPORT_GENERATED: 'Report Generated:',
    INVOICES: 'Invoices',
    INVOICE_HEADER: 'INVOICE',
    CLINIC_NAME: 'DocX Medical Center',
    CLINIC_ADDRESS: '123 Healthcare Ave, Medical District',
    CLINIC_PHONE: 'Phone: (555) 123-4567',
    INVOICE_NUMBER: 'Invoice #:',
    DUE_DATE: 'Due Date:',
    BILL_TO_HEADER: 'Bill To:',
    APPOINTMENT_HEADER: 'Appointment:',
    DESCRIPTION_HEADER: 'Description',
    QTY_HEADER: 'Qty',
    UNIT_PRICE_HEADER: 'Unit Price',
    TOTAL_HEADER: 'Total',
    SUBTOTAL: 'Subtotal:',
    DISCOUNT: 'Discount:',
    TAX: 'Tax:',
    TOTAL_FINAL: 'Total:',
    THANK_YOU_MESSAGE: 'Thank you for choosing DocX Medical Center',
    BILLING_CONTACT: 'For questions, contact billing@docx.com',
    TOTAL_REVENUE: 'Total Revenue',
    PENDING_PAYMENTS: 'Pending Payments',
    INVOICES_THIS_MONTH: 'Invoices This Month',
    TOTAL_INVOICES: 'Total Invoices',
    INVOICE_ID_HEADER: 'Invoice ID',
    PATIENT_HEADER: 'Patient',
    AMOUNT_HEADER: 'Amount',
    STATUS_HEADER: 'Status',
    ACTIONS_HEADER: 'Actions',
    DEV_SHORTCUTS: 'Dev Shortcuts',
    LAB_TEST_REPORT: 'Lab Test Report',
    TEST_ID_LABEL: 'Test ID:',
    TEST_DETAILS: 'Test Details',
    TEST_NAME_LABEL: 'Test Name:',
    ORDERED_DATE_LABEL: 'Ordered Date:',
    STATUS_LABEL: 'Status:',
    RESULT_DATE_LABEL: 'Result Date:',
    RESULTS: 'Results',
    NOTES: 'Notes',
    REPORT_GENERATED_ON: 'Report generated on',
    CONSULTATION_FEE: 'Consultation Fee',
    LAB_TEST_PREFIX: 'Lab Test: ',
    INVOICE_TITLE_PREFIX: 'Invoice',
    INVOICE_DETAILS: 'Invoice Details',
    LINE_ITEMS: 'Line Items',
    INVOICE_DATE_LABEL: 'Invoice Date',
    DUE_DATE_LABEL: 'Due Date',
    APPOINTMENT_DATE_LABEL: 'Appointment Date',
    TOTAL_LABEL: 'Total',
    QUICK_ADD_SERVICES: 'Quick Add Services',
    RATE_HEADER: 'Rate',
    NEW_INVOICE_TITLE: 'New Invoice',
    TAX_PERCENT: 'Tax (%)',
    INVOICE_NOTES: 'Notes',
    SELECT_PATIENT: 'Patient',
    NOTIFICATIONS_TITLE: 'Notifications',
    CHAT_TITLE: 'Chat',
    MY_REVIEWS_TITLE: 'My Reviews',
    NO_NOTIFICATIONS: 'No notifications yet',
    /* B609 — friendlier empty-state subtitle so users know what kind of
     * notifications they should expect (and that the page isn't broken). */
    NO_NOTIFICATIONS_SUBTITLE: "We'll let you know about appointment reminders, doctor messages, and prescription updates here.",
    NO_THREADS: 'No conversations yet',
    NO_MESSAGES: 'No messages yet',
    NO_REVIEWS: 'No reviews yet',
    PENDING_CHANGE_REQUESTS: 'Pending Change Requests',
    RECENT_REVIEWS: 'Recent Reviews',
    AVERAGE_RATING: 'Average Rating',
    TOTAL_REVIEWS: 'Total Reviews',
    RATING_DISTRIBUTION: 'Rating Distribution',
    CHANGE_REQUESTS_INBOX: 'Change Requests',
    PATIENT_UPLOADS: 'Patient Uploads',
    CURRENT_VALUE: 'Current Value',
    PROPOSED_VALUE: 'Proposed Value',
    REASON: 'Reason',
    FIELD: 'Field',
    REVIEWER_COMMENT: 'Reviewer Comment',
    NO_CHANGE_REQUESTS: 'No change requests',
    NO_UPLOADS: 'No uploads yet',
    CATEGORY: 'Category',
    FILE_SIZE: 'File Size',
    UPLOADED: 'Uploaded',
    CHAT: 'Chat',
    REGISTER_DOCTOR_SUBTITLE: 'Register as a new doctor',
    REGISTER_PATIENT_SUBTITLE: 'Create your patient account',
    ACCOUNT_SECTION: 'Account',
    PERSONAL_SECTION: 'Personal',
    PROFESSIONAL_SECTION: 'Professional',
    BROWSE_DOCTORS: 'Browse Doctors',
    MY_RECORDS: 'My Medical Records',
    HELLO: 'Hello',
    UPCOMING_APPOINTMENTS_COUNT: 'Upcoming Appointments',
    ACTIVE_PRESCRIPTIONS: 'Active Prescriptions',
    UNREAD_MESSAGES: 'Unread Messages',
    BOOK_APPOINTMENT: 'Book Appointment',
    VIEW_ALL_APPOINTMENTS: 'View All',
    FIND_DOCTOR: 'Find a Doctor',
    VIEW_RECORDS: 'View Records',
    MESSAGE_DOCTOR: 'Message Doctor',
    UPDATE_PROFILE: 'Update Profile',
    RECENT_ACTIVITY: 'Recent Activity',
    MY_APPOINTMENTS: 'My Appointments',
    DOCTOR_INFO: 'Doctor Info',
    DOCTOR: 'Doctor',
    EXPERIENCE: 'Experience',
    FEE: 'Consultation Fee',
    RATING: 'Rating',
    REVIEWS: 'Reviews',
    AVAILABLE_SLOTS: 'Available Slots',
    NO_SLOTS: 'No slots available',
    SELECT_DATE: 'Select Date',
    SELECT_TIME: 'Select Time',
    APPOINTMENT_REASON: 'Reason for Visit',
    NO_PRESCRIPTIONS: 'No prescriptions found',
    NO_MEDICAL_NOTES: 'No medical notes found',
    NO_TEST_REPORTS: 'No test reports found',
    FILE_CATEGORY: 'Category',
    FILE_DESCRIPTION: 'Description (optional)',
    PERSONAL_INFO: 'Personal Information',
    EMERGENCY_CONTACT: 'Emergency Contact',
    /* B601 — added to LABELS so PatientProfile.tsx can render proper labels
     * for its personal-info form. The PLACEHOLDERS / PATIENT_LABELS /
     * SETTINGS_LABELS namespaces also have these strings, but the consumer
     * was reaching into LABELS, so we keep both in sync here. */
    PHONE: 'Phone Number',
    DATE_OF_BIRTH: 'Date of Birth',
    EMERGENCY_CONTACT_NAME: 'Emergency Contact Name',
    EMERGENCY_CONTACT_PHONE: 'Emergency Contact Phone',
    EMERGENCY_CONTACT_RELATIONSHIP: 'Relationship',
    EMAIL_NOTIFICATIONS: 'Email Notifications',
    SMS_NOTIFICATIONS: 'SMS Notifications',
    SAVE_PREFERENCES: 'Save Preferences',
    /* B709 — patient address field for the Personal Info form. */
    ADDRESS: 'Address',
    CONDITIONS: 'Conditions',
    SURGERIES: 'Surgeries',
    LIFESTYLE: 'Lifestyle',
    BLOOD_TYPE_LABEL: 'Blood Type',
    REQUEST_CHANGE: 'Request Change',
    CHANGE_REASON: 'Reason (optional)',
    IN_APP_NOTIFICATIONS: 'In-App Notifications',
    MEDICATIONS_LIST: 'Medications',
    /* B606 — singular form for "1 medication" rather than "1 medications". */
    MEDICATION_SINGULAR: 'medication',
    PRINT_PRESCRIPTION: 'Print / Download',
    YEARS_EXP: 'yrs exp',
    BIO: 'Bio',
    QUALIFICATIONS: 'Qualifications',
    FILTER_BY_SPECIALIZATION: 'Filter by specialization',
    ALL_SPECIALIZATIONS: 'All',
    UPLOAD_PROGRESS: 'Uploading...',
    SELECT_FILE: 'Select File',
    NO_FILE_SELECTED: 'No file selected',
    STARS: 'stars',
    YOUR_RATING: 'Your Rating',
    REVIEW_COMMENT: 'Comment (optional)',
    THANK_YOU: 'Thank you for your review!',
  },
  PLACEHOLDERS: {
    SEARCH_PATIENTS_APPOINTMENTS: 'Search patients, appointments...',
    SEARCH_PATIENTS: 'Search patients...',
    SEARCH_DOCTORS_APPOINTMENTS: 'Search doctors, appointments...',
    ENTER_EMAIL: 'e.g. you@docx.co.in',
    ENTER_PASSWORD: 'Enter your password',
    ENTER_FULL_NAME: 'Enter your full name',
    ENTER_CONFIRM_PASSWORD: 'Confirm your password',
    ENTER_PHONE: 'e.g. +91 98765 43210',
    ENTER_SPECIALIZATION: 'e.g., General Medicine',
    ENTER_LICENSE_NUMBER: 'e.g., MD-2026-001',
    SELECT_GENDER: 'Select gender',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    DATE_OF_BIRTH: 'Date of Birth',
    EMAIL: 'Email',
    PHONE: 'Phone Number',
    ADDRESS: 'Address',
    ALLERGIES: 'Allergies (comma separated)',
    MEDICATIONS: 'Current Medications (comma separated)',
    EMERGENCY_CONTACT_NAME: 'Emergency Contact Name',
    EMERGENCY_CONTACT_RELATIONSHIP: 'Relationship',
    EMERGENCY_CONTACT_PHONE: 'Emergency Contact Phone',
    ENTER_PATIENT_NAME: 'Type patient name...',
    NEW_PATIENT_HINT: 'New patient',
    /* B709 — placeholder for the patient address textarea. */
    ENTER_ADDRESS: 'Street, city, state, postal code',
    ADD_APPOINTMENT_NOTES: 'Add notes about this appointment...',
    HEART_RATE: 'e.g., 72 bpm',
    BLOOD_PRESSURE: 'e.g., 120/80 mmHg',
    TEMPERATURE: 'e.g., 98.6°F',
    WEIGHT: 'e.g., 70 kg',
    RESPIRATORY_RATE: 'e.g., 16 breaths/min',
    OXYGEN_SATURATION: 'e.g., 98%',
    CHIEF_COMPLAINT_TEXT: 'What brings the patient in today?',
    CLINICAL_DIAGNOSIS: 'Clinical diagnosis...',
    MEDICATION_NAME: 'e.g., Paracetamol',
    MEDICATION_DOSAGE: 'e.g., 500mg',
    MEDICATION_FREQUENCY: 'e.g., Twice daily',
    MEDICATION_INSTRUCTIONS: 'e.g., After meals',
    MEDICATION_DURATION: 'e.g., 5 days',
    GENERAL_ADVICE: 'Enter general advice for the patient...',
    ADDITIONAL_NOTES: 'Additional notes, observations, or recommendations...',
    SEARCH_INVOICES: 'Search invoices...',
    ITEM_DESCRIPTION: 'Service description...',
    INVOICE_NOTES: 'Additional notes for this invoice...',
    SEARCH_APPOINTMENTS: 'Search appointments...',
    ENTER_TEST_NAME: 'Enter test name',
    ENTER_SYMPTOM_NAME: 'Enter symptom name',
    SEND_MESSAGE: 'Type a message... (Enter to send)',
    REVIEWER_COMMENT: 'Optional comment...',
    APPOINTMENT_REASON: 'e.g. Annual checkup, follow-up for...',
    CHANGE_REASON: 'Reason for the change (optional)',
    PROPOSED_VALUE: 'Enter proposed value',
    REVIEW_COMMENT: 'Share your experience (optional)',
    FILE_DESCRIPTION: 'Brief description (optional)',
    SEARCH_DOCTORS: 'Search by name or specialization...',
  },
  OPTIONS: {
    ALL_TYPES: 'All Types',
    GENERAL_CHECKUP: 'General Checkup',
    FOLLOW_UP: 'Follow-up',
    CONSULTATION: 'Consultation',
    PHYSICAL_EXAM: 'Physical Exam',
    LAB_REVIEW: 'Lab Review',
    SORT_BY_TIME: 'Sort by Time',
    SORT_BY_PATIENT_NAME: 'Sort by Patient Name',
    SORT_BY_DOCTOR_NAME: 'Sort by Doctor Name',
    SORT_BY_STATUS: 'Sort by Status',
    SORT_BY_TYPE: 'Sort by Type',
    ALL_STATUS: 'All Status',
    PAID: 'Paid',
    PENDING: 'Pending',
    OVERDUE: 'Overdue',
    ALL_TIME: 'All Time',
    THIS_MONTH: 'This Month',
    LAST_MONTH: 'Last Month',
    ALL_GENDERS: 'All Genders',
    MALE: 'Male',
    FEMALE: 'Female',
    OTHER: 'Other',
    ENGLISH: 'English',
    SPANISH: 'Spanish',
    FRENCH: 'French',
    PACIFIC_TIME: 'Pacific Time (PT)',
    EASTERN_TIME: 'Eastern Time (ET)',
    CENTRAL_TIME: 'Central Time (CT)',
    DATE_MM_DD_YYYY: 'MM/DD/YYYY',
    DATE_DD_MM_YYYY: 'DD/MM/YYYY',
    DATE_YYYY_MM_DD: 'YYYY-MM-DD',
    TIME_12_HOUR: '12-hour',
    TIME_24_HOUR: '24-hour',
    SELECT_BLOOD_TYPE: 'Select Blood Type',
    SELECT_GENDER: 'Select Gender',
    GENERATED: 'Generated',
  },
  ARIA_LABELS: {
    NOTIFICATIONS: 'Notifications',
    MESSAGES: 'Messages',
    TOGGLE_PASSWORD: 'Toggle password visibility',
    AVATAR_OF: 'Avatar of',
    SEARCH_PATIENTS: 'Search patients',
    SCROLL_LEFT: 'Scroll left',
    SCROLL_RIGHT: 'Scroll right',
    NOTIFICATIONS_BELL: 'View notifications',
    NOTIFICATION_UNREAD_DOT: 'Unread notifications',
  },
  TITLES: {
    DEV_QUICK_LOGIN: 'Development only: Quick login as Dr. Sarah Johnson',
    CLOSE_CONSULTATION: 'Close consultation',
  },
  STATUS_LABELS: {
    ACTIVE: 'Active',
    PENDING: 'Pending',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    SCHEDULED: 'Scheduled',
    NO_SHOW: 'No-Show',
  },
  MESSAGES: {
    LOADING: 'Loading...',
    EMPTY_VALUE: '',
    ENV_DEVELOPMENT: 'development',
    SUCCESS_SAVE: 'Successfully saved',
    FEATURE_COMING_SOON: 'This feature is being finalized.',
    COMING_IN_NEXT_UPDATE: 'Coming in next update.',
    ACTION_COMPLETED: 'Action completed successfully.',
    ACTION_FAILED: 'Something went wrong. Please try again.',
    SEARCH_RESULTS_FOR: 'Results for',
    CONSULTATION_ALREADY_ACTIVE: 'A consultation session is already active',
    LOADING_APPOINTMENT_DETAILS: 'Loading appointment details...',
    LOADING_PATIENT_DETAILS: 'Loading patient details...',
    FAILED_LOAD_PATIENT_DETAILS: 'Failed to load patient details. Please try again.',
    FAILED_LOAD_APPOINTMENT_DETAILS: 'Failed to load appointment details. Please try again.',
    OOPS_THATS_ON_US: 'Oops, that\'s on us!',
    OOPS_APPOINTMENT_SUBTITLE: 'We were still setting things up when you got here. Try refreshing the page or head back and give it another go.',
    RELOAD_PAGE: 'Reload Page',
    GO_TO_DASHBOARD: 'Go to Dashboard',
    ERROR_BOUNDARY_DETAILS_SUMMARY: 'Technical details',
    LOAD_APPOINTMENTS_FAILED: "Couldn't load appointments. Please try again.",
    LOAD_PATIENTS_FAILED: "Couldn't load patients. Please try again.",
    LOAD_INVOICES_FAILED: "Couldn't load invoices. Please try again.",
    /* B604 — patient-facing 'load failed' messages so the empty/error
     * state ambiguity is resolved across every patient surface. */
    LOAD_DOCTORS_FAILED: "Couldn't load doctors. Please try again.",
    LOAD_PRESCRIPTIONS_FAILED: "Couldn't load your prescriptions. Please try again.",
    LOAD_MEDICAL_NOTES_FAILED: "Couldn't load your medical notes. Please try again.",
    LOAD_TEST_REPORTS_FAILED: "Couldn't load your test reports. Please try again.",
    LOAD_UPLOADS_FAILED: "Couldn't load your uploads. Please try again.",
    LOAD_PROFILE_FAILED: "Couldn't load your profile. Please try again.",
    LOAD_REVIEWS_FAILED: "Couldn't load reviews. Please try again.",
    LOAD_SLOTS_FAILED: "Couldn't load available slots. Please try again.",
    LOAD_CHAT_THREADS_FAILED: "Couldn't load your conversations. Please try again.",
    LOAD_NOTIFICATIONS_FAILED: "Couldn't load notifications. Please try again.",
    NO_CHIEF_COMPLAINT: 'No chief complaint recorded',
    NOT_SPECIFIED: 'Not specified',
    UNKNOWN: 'Unknown',
    UNKNOWN_PATIENT: 'Unknown Patient',
    UNKNOWN_PATIENT_ID: '#PT-UNKNOWN',
    LOADING_TEST_REPORT: 'Loading test report...',
    TEST_NOT_FOUND: 'Test not found',
    TEST_REPORT_NOT_FOUND: 'Test report not found.',
    LOADING_APPOINTMENT_REPORT: 'Loading appointment report...',
    CREATE_NEW_INVOICE: 'Create a new invoice',
    CONFIRM_COMPLETE_CONSULTATION: 'Are you sure you want to complete this consultation? This will generate the final report.',
    CONFIRM_CANCEL_CONSULTATION: 'Are you sure you want to cancel? Any unsaved changes will be lost.',
    NEW_MEDICATION: 'New Medication',
    VITALS_PATIENT_NOT_FOUND: 'Cannot update vitals: Patient not found',
    VITALS_UPDATED_SUCCESSFULLY: 'Vitals updated successfully',
    VITALS_UPDATE_FAILED: 'Failed to update vitals. Please try again.',
    NO_APPOINTMENT_SELECTED: 'No appointment selected',
    PATIENT_FALLBACK: 'Patient',
    CONSULTATION_FALLBACK: 'Consultation',
    REPORT_FALLBACK: 'Report',
    SAVE_CONSULTATION_FAILED: 'Failed to save consultation. Please try again.',
    CONFIRM_CANCEL_APPOINTMENT: 'Are you sure you want to cancel this appointment? This action cannot be undone.',
    APPOINTMENT_CANCELLED_SUCCESSFULLY: 'Appointment cancelled successfully',
    CANCEL_APPOINTMENT_FAILED: 'Failed to cancel appointment. Please try again.',
    CONFIRM_EXIT_CONSULTATION: 'Viewing a previous appointment will exit the current consultation. Any unsaved changes will be lost. Do you want to continue?',
    NOTES_SAVED_SUCCESSFULLY: 'Notes saved successfully',
    SAVE_NOTES_FAILED: 'Failed to save notes. Please try again.',
    RESCHEDULE_APPOINTMENT_FAILED: 'Failed to reschedule appointment. Please try again.',
    APPOINTMENT_CREATED: 'Appointment Created',
    APPOINTMENT_RESCHEDULED: 'Appointment Rescheduled',
    INVOICE_CREATED_SUCCESSFULLY: 'Invoice Created',
    INVOICE_CREATE_FAILED: 'Failed to create invoice. Please try again.',
    MIN_ONE_LINE_ITEM: 'At least one line item is required',
    ITEM_DESCRIPTION_REQUIRED: 'Item description is required',
    INVOICE_DEMO_MODE: 'Invoice data is loaded from your account. Complete consultations to generate invoices.',
    NO_PREVIOUS_APPOINTMENTS: 'No previous appointments',
    NO_PREVIOUS_TESTS: 'No previous tests',
    NO_ITEMS: 'No items',
    CHANGE_REQUEST_APPROVED: 'Change request approved successfully',
    CHANGE_REQUEST_REJECTED: 'Change request rejected',
    VIEW_PRESCRIPTION_PHASE_5: 'View prescription — coming in Phase 5.',
    NO_RECENT_ACTIVITY: 'No recent activity.',
    UNKNOWN_DOCTOR: 'Unknown Doctor',
    NOT_ASSIGNED: 'Not assigned',
    APPOINTMENT_BOOKED: 'Appointment booked successfully!',
    UPLOAD_FAILED: 'Failed to upload file. Please try again.',
    DELETE_UPLOAD_CONFIRM: 'Are you sure you want to delete this file?',
    PROFILE_UPDATED: 'Profile updated successfully.',
    PROFILE_UPDATE_FAILED: 'Failed to update profile.',
    CHANGE_REQUEST_FAILED: 'Failed to submit change request.',
    NOTIFICATION_PREFS_SAVED: 'Notification preferences saved.',
    NOTIFICATION_PREFS_FAILED: 'Failed to save notification preferences.',
    SEND_MESSAGE_FAILED: 'Failed to send message.',
    REVIEW_FAILED: 'Failed to submit review.',
    NO_DOCTORS_FOUND: 'No doctors found.',
  },
  STORAGE_KEYS: {
    THEME: 'docx_theme',
  },
  THEME: {
    TOGGLE_THEME: 'Toggle theme',
  },
   SEPARATORS: {
     SPACE: ' ',
       AT: '@',
       PLUS: '+',
       BULLET: '•',
   },
  UNITS: {
    MINUTES: 'minutes',
    BPM: 'bpm',
    MMHG: 'mmHg',
    DEG_F: '°F',
    KG: 'kg',
    PER_MIN: '/min',
    PERCENT: '%',
  },
  TABS: {
    ALL_APPOINTMENTS: 'All Appointments',
    TODAY: 'Today',
    UPCOMING: 'Upcoming',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    OVERVIEW: 'Overview',
    MEDICAL_HISTORY: 'Medical History',
    PROFILE: 'Profile',
    ACCOUNT_SECURITY: 'Account & Security',
    PREFERENCES: 'Preferences',
    CHAT: 'Chat',
    PATIENT_UPLOADS: 'Patient Uploads',
    CHANGE_REQUESTS: 'Change Requests',
    PRESCRIPTIONS: 'Prescriptions',
    MEDICAL_NOTES: 'Medical Notes',
    TEST_REPORTS: 'Test Reports',
    MY_UPLOADS: 'My Uploads',
    PERSONAL_INFO: 'Personal Info',
    MEDICAL_HISTORY_TAB: 'Medical History',
    NOTIFICATIONS_PREFS: 'Notification Preferences',
    ACCOUNT: 'Account',
    DOCTORS: 'Doctors',
    DOCTOR_INFO: 'Doctor Info',
    REVIEWS: 'Reviews',
    SLOTS: 'Available Slots',
  },
  ICONS: {
    ADD: '+',
    ALARM: 'alarm',
    ARROW_BACK: 'arrow_back',
    ATTACH_FILE: 'attach_file',
    BADGE: 'badge',
    CAKE: 'cake',
    CALENDAR_TODAY: 'calendar_today',
    CANCEL: 'cancel',
    CHAT: 'chat',
    CHAT_BUBBLE_OUTLINE: 'chat_bubble_outline',
    CHECK_CIRCLE: 'check_circle',
    CONTACT_PHONE: 'contact_phone',
    DARK_MODE: 'dark_mode',
    DESCRIPTION: 'description',
    DONE_ALL: 'done_all',
    DOWNLOAD: 'download',
    EDIT: 'edit',
    EDIT_NOTE: 'edit_note',
    EMAIL: 'email',
    EMERGENCY: 'emergency',
    ERROR_OUTLINE: 'error_outline',
    EVENT: 'event',
    EVENT_AVAILABLE: 'event_available',
    EVENT_BUSY: 'event_busy',
    EVENT_REPEAT: 'event_repeat',
    FAMILY_RESTROOM: 'family_restroom',
    FEMALE: 'female',
    HEALTH_AND_SAFETY: 'health_and_safety',
    LIGHT_MODE: 'light_mode',
    LOGOUT: 'logout',
    MALE: 'male',
    MANAGE_ACCOUNTS: 'manage_accounts',
    MEDICAL_INFORMATION: 'medical_information',
    MEDICAL_SERVICES: 'medical_services',
    MEDICATION: 'medication',
    MEETING_ROOM: 'meeting_room',
    MONITOR_HEART: 'monitor_heart',
    NOTE_ADD: 'note_add',
    NOTIFICATIONS: 'notifications',
    NOTIFICATIONS_NONE: 'notifications_none',
    PERSON: 'person',
    PLAY_ARROW: 'play_arrow',
    REFRESH: 'refresh',
    SCHEDULE: 'schedule',
    SEARCH: 'search',
    SEND: 'send',
    SMART_TOY: 'smart_toy',
    STAR: 'star',
    STAR_BORDER: 'star_border',
    STAR_SYMBOL: '★',
    TIMER: 'timer',
    TRANSGENDER: 'transgender',
    UPLOAD_FILE: 'upload_file',
    VERIFIED: 'verified',
    WATER_DROP: 'water_drop',
    HELP: 'help',
    PRIORITY_HIGH: 'priority_high',
  },
  PAGINATION: {
    SHOWING: 'Showing',
    OF: 'of',
    APPOINTMENTS: 'appointments',
    PATIENTS: 'patients',
    INVOICES: 'invoices',
  },
  PATIENT_LABELS: {
    YEARS: 'years',
    FULL_NAME: 'Full Name',
    DATE_OF_BIRTH: 'Date of Birth',
    PHONE_NUMBER: 'Phone Number',
    EMAIL_ADDRESS: 'Email Address',
    RELATIONSHIP: 'Relationship',
    NO_KNOWN_ALLERGIES: 'No known allergies',
    GENDER: 'Gender',
    BLOOD_TYPE: 'Blood Type',
    ADDRESS: 'Address',
    NAME: 'Name',
    CURRENT_MEDICATIONS: 'Current Medications',
    PREVIOUS_APPOINTMENTS: 'Previous Appointments',
    NO_CURRENT_MEDICATIONS: 'No current medications',
    DOSAGE_DETAILS: 'Dosage and frequency details would go here',
  },
  SETTINGS_LABELS: {
    SETTINGS: 'Settings',
    PROFILE_INFORMATION: 'Profile Information',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    CHANGE_PHOTO: 'Change Photo',
    REMOVE: 'Remove',
    SAVE_CHANGES: 'Save Changes',
    PROFESSIONAL_DETAILS: 'Professional Details',
    SPECIALIZATION: 'Specialization',
    EDUCATION: 'Education',
    LICENSE_NUMBER: 'License Number',
    YEARS_OF_EXPERIENCE: 'Years of Experience',
    WORKING_HOURS: 'Working Hours',
    START_TIME: 'Start Time',
    END_TIME: 'End Time',
    SECURITY_SETTINGS: 'Security Settings',
    CHANGE_PASSWORD: 'Change Password',
    CHANGE: 'Change',
    CURRENT_PASSWORD: 'Current Password',
    NEW_PASSWORD: 'New Password',
    CONFIRM_NEW_PASSWORD: 'Confirm New Password',
    UPDATE_PASSWORD: 'Update Password',
    TWO_FACTOR_AUTH: 'Two-Factor Authentication',
    ENABLE: 'Enable',
    DISABLE: 'Disable',
    SESSION_MANAGEMENT: 'Session Management',
    SIGN_OUT_ALL: 'Sign Out All Devices',
    NOTIFICATION_PREFERENCES: 'Notification Preferences',
    EMAIL_NOTIFICATIONS: 'Email Notifications',
    PUSH_NOTIFICATIONS: 'Push Notifications',
    SMS_NOTIFICATIONS: 'SMS Notifications',
    APP_PREFERENCES: 'App Preferences',
    LANGUAGE: 'Language',
    DATE_FORMAT: 'Date Format',
    TIME_FORMAT: 'Time Format',
    TIMEZONE: 'Timezone',
    REVOKE: 'Revoke',
    SAVE_PREFERENCES: 'Save Preferences',
    ACTIVE_SESSIONS: 'Active Sessions',
    CURRENT: 'Current',
    DATA_MANAGEMENT: 'Data Management',
    RESET_LOCAL_DATA: 'Reset Local Data',
    RESET_LOCAL_DATA_DESC: 'Clear cached invoice data and restore defaults',
    RESET: 'Reset',
    NOTIFICATIONS: 'Notification Preferences',
    APPOINTMENT_ALERTS: 'Appointment Alerts',
    PATIENT_MESSAGES: 'Patient Messages',
    SYSTEM_UPDATES: 'System Updates',
    LANGUAGE_TIME: 'Language & Time',
    APPEARANCE: 'Appearance',
    THEME: 'Theme',
    THEME_DESC: 'Choose how the app looks. Auto follows your system setting.',
    THEME_LIGHT: 'Light',
    THEME_DARK: 'Dark',
    THEME_AUTO: 'Auto',
    TWO_FACTOR_AUTH_DESC: 'Require a verification code in addition to your password',
    ENTER_NEW_PASSWORD: 'Enter new password',
    CONFIRM_NEW_PASSWORD_PLACEHOLDER: 'Confirm new password',
    PASSWORD_MASK: '••',
    RESET_CONFIRM: 'This will clear all local invoice data and reset to defaults. Continue?',
    DATA_RESET_SUCCESS: 'Local data has been reset. Please refresh the page.',
    REVOKE_CONFIRM: 'Are you sure you want to revoke this session? The device will be signed out.',
    REVOKE_ALL_CONFIRM: 'Sign out all other devices? Only your current session will remain active.',
    NO_ACTIVE_SESSIONS: 'No active sessions found.',
    ON: 'on',
    CURRENT_SESSION_LABEL: 'This device — active now',
    LAST_ACTIVE: 'Last active',
  },
  MODAL_LABELS: {
    NEW_DATE: 'New Date',
    NEW_TIME: 'New Time',
    CONFIRM_RESCHEDULE: 'Confirm Reschedule',
    APPOINTMENT_DATE: 'Appointment Date',
    APPOINTMENT_TIME: 'Appointment Time',
    APPOINTMENT_DURATION: 'Duration (minutes)',
    APPOINTMENT_ROOM: 'Room',
    APPOINTMENT_NOTES: 'Notes',
    APPOINTMENT_TYPE: 'Type',
    SELECT_PATIENT: 'Select Patient',
    PATIENT_NAME: 'Patient Name',
    PATIENT_AGE: 'Age',
    PATIENT_GENDER: 'Gender',
    BOOK_APPOINTMENT: 'Book Appointment',
    SELECT_DATE: 'Select Date',
    SELECT_TIME: 'Select a Time Slot',
    APPOINTMENT_DETAILS_STEP: 'Appointment Details',
    PRESCRIPTION_DETAILS: 'Prescription Details',
    UPLOAD_FILE: 'Upload File',
    CHANGE_REQUEST: 'Request Change',
    LEAVE_REVIEW: 'Leave a Review',
  },
  HISTORY_LABELS: {
    KNOWN_ALLERGIES: 'Known Allergies',
    FAMILY_HISTORY: 'Family History',
    PAST_SURGERIES: 'Past Surgeries',
    LIFESTYLE_HABITS: 'Lifestyle & Habits',
    PREVIOUS_CONDITIONS: 'Previous Conditions',
    PREVIOUS_TESTS: 'Previous Tests',
  },
  EMPTY_APPOINTMENTS: {
    NO_APPOINTMENTS_FOUND: 'No appointments found matching the current filters.',
  },
  SPLIT_VIEW: {
    CLOSE_WINDOW: 'Close Window',
    CLOSE_ALL_WINDOWS: 'Close All',
    WINDOW_COUNT: 'windows',
    MAX_WINDOWS_REACHED: 'Maximum windows reached',
    CANNOT_FIT_WINDOW: 'Cannot open window - screen too small',
    AUTO_SAVED: 'Auto-saved',
    SAVING: 'Saving...',
    VIEW_PREVIOUS_APPOINTMENT: 'View Previous Visit',
    VIEW_MEDICAL_HISTORY: 'View Medical History',
    VIEW_TEST_RESULTS: 'View Test Results',
    VIEW_PRESCRIPTION: 'View Prescription',
    VIEW_PATIENT_DETAILS: 'View Patient Details',
    WINDOW_POSITION: 'Window',
    KEEP_OPEN: 'Keep Open',
    MINIMIZE: 'Minimize',
    RESTORE: 'Restore',
  },
  AI_ASSIST: {
    BRIEF: {
      TITLE: 'AI brief',
      DRAFTING: 'Drafting…',
      ARIA_REGION: 'AI patient brief',
      ARIA_REFRESH: 'Regenerate AI brief',
      ERROR: 'Could not generate brief. Click refresh to retry.',
    },
    SAFETY: {
      TITLE: 'AI safety check',
      SUBTITLE: 'Verify clinically before signing',
      ARIA_REGION: 'AI medication safety warnings',
      LOADING: 'Checking for interactions and allergy conflicts…',
      ERROR: 'Couldn\u2019t check medication safety. Please verify manually.',
      CLEAR: 'AI found no obvious interactions or allergy conflicts. Verify clinically before signing.',
      DEFAULT_ALLERGIES: 'NKDA',
      SEVERITY_CRITICAL: 'critical',
      SEVERITY_HIGH: 'high',
      SEVERITY_MODERATE: 'moderate',
      SEVERITY_INFO: 'info',
    },
    BOOK_SYMPTOM_CHECKER: {
      QUICK_SYMPTOMS: 'Common symptoms',
      QUICK_SYMPTOMS_HINT: 'Tap a symptom to add it to your reason. AI will refine it for the doctor.',
      CLARIFY_TITLE: 'AI follow-up questions',
      CLARIFY_SUBTITLE: 'Answering these helps the doctor prepare. Optional.',
      CLARIFY_LOADING: 'Generating follow-up questions…',
      CLARIFY_ERROR: 'Couldn\u2019t generate follow-up questions. You can still book.',
      MIN_LENGTH_HINT: 'Add a few more details so the AI can help…',
      AI_TEXTAREA_LABEL: 'Describe your symptoms',
    },
  },
  AI_TRIAGE: {
    LABELS: {
      PAGE_TITLE: 'AI Triage Inbox',
      AWAITING_REVIEW: 'Awaiting Review',
      NEEDS_MORE_INFO: 'Needs More Info',
      URGENCY_LOW: 'Low',
      URGENCY_MEDIUM: 'Medium',
      URGENCY_HIGH: 'High',
      URGENCY_EMERGENCY: 'Emergency',
      CONFIDENCE_LOW: 'Low confidence',
      CONFIDENCE_MEDIUM: 'Medium confidence',
      CONFIDENCE_HIGH: 'High confidence',
      CHIEF_COMPLAINT: 'Chief Complaint',
      SYMPTOMS: 'Symptoms',
      SUGGESTED_DIAGNOSIS: 'Suggested Diagnosis',
      ICD_CODE: 'ICD Code',
      MEDICATIONS: 'Medications',
      LAB_TESTS: 'Lab Tests',
      SPECIALTY: 'Specialty',
      CONFIDENCE: 'AI Confidence',
      RED_FLAGS: 'Red Flags',
      NOTES: 'Notes',
      TRANSCRIPT: 'Chat Transcript',
      EDIT_DRAFT: 'Edit AI Draft',
      DIAGNOSIS: 'Diagnosis',
      REJECT_REASON: 'Reason for rejection',
      NEEDS_MORE_INFO_QUESTION: 'Question for patient',
      STATUS_DRAFT: 'Draft',
      STATUS_AWAITING: 'Awaiting Review',
      STATUS_NEEDS_MORE: 'Needs More Info',
      STATUS_APPROVED: 'Approved',
      STATUS_REJECTED: 'Rejected',
      STATUS_CANCELLED: 'Cancelled',
      SUBMITTED_AT: 'Submitted',
      WAITING_TIME: 'Waiting',
      EMPTY_QUEUE: 'No cases in this queue',
      EMPTY_QUEUE_SUBTITLE: 'New AI consultations submitted by patients will appear here.',
      APPROVE_SUCCESS: 'Consultation approved successfully.',
      REJECT_SUCCESS: 'Consultation rejected.',
      NEEDS_MORE_INFO_SUCCESS: 'Patient has been asked for more information.',
      DRAFT_FOOTER: 'Draft — pending doctor review',
      DOSAGE: 'Dosage',
      FREQUENCY: 'Frequency',
      TIMING: 'Timing',
      DURATION: 'Duration',
      MEDICINE: 'Medicine',
    },
    BUTTONS: {
      APPROVE: 'Approve',
      REJECT: 'Reject',
      NEEDS_MORE_INFO: 'Needs More Info',
      SUBMIT_REJECTION: 'Submit Rejection',
      SUBMIT_QUESTION: 'Send Question',
      ADD_SYMPTOM: 'Add Symptom',
      ADD_TEST: 'Add Test',
      ADD_MEDICATION: 'Add Medication',
      REMOVE: 'Remove',
    },
    PLACEHOLDERS: {
      REJECT_REASON: 'Enter reason for rejection...',
      NEEDS_MORE_INFO_QUESTION: 'Enter your question for the patient...',
      SYMPTOM: 'Add symptom...',
      LAB_TEST: 'Add lab test...',
      CHIEF_COMPLAINT: 'Chief complaint...',
      DIAGNOSIS: 'Diagnosis...',
      ICD_CODE: 'ICD code...',
      SPECIALTY: 'Specialty...',
      MED_NAME: 'Medicine name...',
      MED_DOSAGE: 'Dosage...',
      MED_FREQUENCY: 'Frequency...',
      MED_TIMING: 'Timing...',
      MED_DURATION: 'Duration...',
      NOTES: 'Additional notes...',
    },
    ARIA_LABELS: {
      APPROVE_CONSULTATION: 'Approve AI consultation',
      REJECT_CONSULTATION: 'Reject AI consultation',
      NEEDS_MORE_INFO: 'Request more information from patient',
      BACK_TO_LIST: 'Back to triage list',
    },
  },
  OCR: {
    BUTTONS: {
      UPLOAD_REPORT: 'Upload Report',
      UPLOAD_OFFLINE_REPORT: 'Upload Offline Report',
      CHOOSE_FILE: 'Choose file',
      REPLACE_FILE: 'Replace file',
      EXTRACT: 'Extract',
      RE_EXTRACT: 'Re-extract',
      APPLY_TO_PATIENT: 'Apply to Patient',
      APPLY_TO_CONSULTATION: 'Apply to Consultation',
      ADD_TO_ADVICE: 'Add to advice',
      REGENERATE_SUGGESTIONS: 'Regenerate suggestions',
    },
    LABELS: {
      MODAL_TITLE: 'Upload Offline Report',
      DROP_HINT: 'Drag & drop a report, or click to choose',
      ACCEPTED_TYPES: 'PNG, JPG, WEBP, or PDF (max 15MB)',
      FILE_PREVIEW: 'File preview',
      EXTRACTED_DATA: 'Extracted data',
      AI_SUGGESTIONS: 'AI dietary & lifestyle suggestions',
      DIETARY_SUGGESTIONS: 'Dietary suggestions',
      LIFESTYLE_SUGGESTIONS: 'Lifestyle suggestions',
      REPORT_TITLE: 'Report title',
      REPORT_TYPE: 'Report type',
      REPORT_DATE: 'Report date',
      ARCHIVE_ORIGINAL: 'Archive original report to medical records',
      SECTION_VITALS: 'Vitals',
      SECTION_LAB_VALUES: 'Lab values',
      SECTION_DIAGNOSES: 'Diagnoses',
      SECTION_MEDICATIONS: 'Medications',
      SECTION_ALLERGIES: 'Allergies',
      SECTION_CONDITIONS: 'Conditions',
      SECTION_SUMMARY: 'Summary',
      VITAL_BLOOD_PRESSURE: 'Blood pressure',
      VITAL_HEART_RATE: 'Heart rate',
      VITAL_TEMPERATURE: 'Temperature',
      VITAL_WEIGHT: 'Weight',
      VITAL_HEIGHT: 'Height',
      VITAL_RESPIRATORY_RATE: 'Respiratory rate',
      VITAL_OXYGEN_SATURATION: 'Oxygen saturation',
      LAB_NAME: 'Test',
      LAB_VALUE: 'Value',
      LAB_UNIT: 'Unit',
      LAB_RANGE: 'Reference range',
      LAB_FLAG: 'Flag',
      MED_NAME: 'Medication',
      MED_DOSAGE: 'Dosage',
      MED_FREQUENCY: 'Frequency',
      MED_DURATION: 'Duration',
      CONFIDENCE: 'Confidence',
    },
    PLACEHOLDERS: {
      REPORT_TITLE: 'e.g. CBC Lab Report — Jan 15',
      ADD_ALLERGY: 'Add allergy…',
      ADD_DIAGNOSIS: 'Add diagnosis…',
      ADD_CONDITION: 'Add condition…',
    },
    MESSAGES: {
      UPLOADING: 'Uploading…',
      EXTRACTING: 'Reading report and extracting data…',
      APPLYING: 'Applying to patient record…',
      EXTRACT_FAILED: 'Could not extract data from this report.',
      APPLY_FAILED: 'Failed to update patient record.',
      APPLIED_SUCCESS: 'Patient record updated from report.',
      APPLIED_TO_CONSULTATION: 'Extracted data added to consultation.',
      NO_FINDINGS: 'No structured findings detected. Try a clearer image or a digital PDF.',
      AI_UNCONFIGURED:
        'AI extraction is not configured. Set AZURE_OPENAI_VISION_MODEL on the backend to enable.',
      CONFIRM_OVERWRITE_ADVICE:
        'You already have advice text — append AI suggestions to it?',
      FILE_TOO_LARGE: 'File is too large. Max 15MB.',
      UNSUPPORTED_TYPE: 'Unsupported file type. Use PNG, JPG, WEBP, or PDF.',
    },
  },
  NOT_FOUND: {
    BADGE: '404',
    HEADLINE: 'This page does not exist',
    SUBHEADLINE:
      "The link you followed may be broken, or the page may have been moved. Let's get you back to a familiar place.",
    PRIMARY_CTA: 'Back to home',
    SECONDARY_CTA: 'Sign in',
  },
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  PASSWORD_TOO_SHORT: 'Password must be at least 6 characters',
  LOGIN_FAILED: 'Login failed. Please try again.',
  PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
  EMAIL_ALREADY_EXISTS: 'This email is already registered',
  LICENSE_ALREADY_EXISTS: 'This license number is already registered',
  REGISTRATION_FAILED: 'Registration failed. Please try again.',
  GOOGLE_AUTH_FAILED: 'Google sign-in failed. Please try again.',
  NAME_TOO_SHORT: 'Name must be at least 2 characters',
  SPECIALIZATION_REQUIRED: 'Specialization is required',
  LICENSE_REQUIRED: 'License number is required',
  GENDER_REQUIRED: 'Please select a gender',
  PROFILE_COMPLETION_FAILED: 'Failed to complete profile. Please try again.',
} as const;

/**
 * Marketing copy for the public landing page (docx.co.in).
 * Keep tone confident, doctor-first, and India-aware.
 */
export const LANDING_STRINGS = {
  NAV: {
    BRAND: 'DocX',
    LINK_FEATURES: 'Features',
    LINK_HOW_IT_WORKS: 'How it works',
    LINK_FOR_DOCTORS: 'For doctors',
    SIGN_IN: 'Sign in',
    GET_STARTED: 'Get started free',
    OPEN_MENU: 'Open menu',
    CLOSE_MENU: 'Close menu',
  },
  HERO: {
    PILL: 'Built for modern Indian clinics',
    HEADLINE_LINE_1: 'Run your practice',
    HEADLINE_LINE_2: 'on one clean screen.',
    SUBHEADLINE:
      'DocX is the everyday OS for doctors — appointments, consultations, prescriptions, and invoices in a workflow that actually feels designed for you.',
    PRIMARY_CTA: 'Get started free',
    PATIENT_CTA: "I'm a patient",
    DOCTOR_CTA: "I'm a doctor",
    TRUST_LINE: 'No credit card. Free for the first 50 doctors. Set up in minutes.',
    MOCK_URL: 'docx.co.in/dashboard',
    MOCK_HEADER: 'Today · Tuesday',
    MOCK_GREETING: 'Good morning, Dr. Mehra',
    MOCK_STAT_TODAY: "Today's appointments",
    MOCK_STAT_TODAY_VALUE: '14',
    MOCK_STAT_PATIENTS: 'Active patients',
    MOCK_STAT_PATIENTS_VALUE: '1,284',
    MOCK_STAT_REVENUE: 'This week',
    MOCK_STAT_REVENUE_VALUE: '₹86,200',
    MOCK_LIST_TITLE: 'Up next',
    MOCK_ROW_1_NAME: 'Amy Chen',
    MOCK_ROW_1_TYPE: 'Follow-up · 10:30 AM',
    MOCK_ROW_1_STATUS: 'Confirmed',
    MOCK_ROW_2_NAME: 'Rahul Singh',
    MOCK_ROW_2_TYPE: 'New consult · 11:00 AM',
    MOCK_ROW_2_STATUS: 'Waiting',
    MOCK_ROW_3_NAME: 'Priya Iyer',
    MOCK_ROW_3_TYPE: 'Lab review · 11:30 AM',
    MOCK_ROW_3_STATUS: 'Confirmed',
  },
  STATS: {
    STAT_1_VALUE: '< 30s',
    STAT_1_LABEL: 'to write a prescription',
    STAT_2_VALUE: '0 paper',
    STAT_2_LABEL: 'paperless workflow end-to-end',
    STAT_3_VALUE: '99.9%',
    STAT_3_LABEL: 'uptime on Google Cloud',
    STAT_4_VALUE: '7-day',
    STAT_4_LABEL: 'JWT sessions, encrypted at rest',
  },
  PROBLEM: {
    EYEBROW: 'The problem',
    HEADLINE: 'Most clinic software was built for billing, not for medicine.',
    BODY:
      'Doctors are stuck switching between paper, WhatsApp, Excel, and clunky billing tools. Notes get lost, prescriptions are illegible, and follow-ups depend on memory. DocX rebuilds the workflow around the consultation itself.',
    POINT_1: 'Notes scattered across paper, WhatsApp, and memory',
    POINT_2: 'Prescriptions slow, error-prone, and hard to share',
    POINT_3: 'No clear view of today, this week, or this patient',
    POINT_4: 'Billing apps that ignore how a consultation actually flows',
  },
  FEATURES: {
    EYEBROW: 'Features',
    HEADLINE: 'Everything you need. Nothing you don\u2019t.',
    SUBHEADLINE:
      'Each surface is designed around the doctor\u2019s real workflow — not adapted from a generic CRM.',
    F1_TITLE: 'Smart appointments',
    F1_BODY:
      'See today, tomorrow, and the week at a glance. Reschedule with a click. Filter by status, type, or patient instantly.',
    F1_ICON: 'event_available',
    F2_TITLE: 'Consultation cockpit',
    F2_BODY:
      'A focused split-view for each visit — patient context on the left, your notes, prescriptions, and labs on the right.',
    F2_ICON: 'stethoscope',
    F3_TITLE: 'Digital prescriptions',
    F3_BODY:
      'Pick from a smart medicine library. Set dose, frequency, duration in seconds. Print or share — every script is legible.',
    F3_ICON: 'medication',
    F4_TITLE: 'Patient records',
    F4_BODY:
      'A complete, searchable history per patient — vitals, allergies, past consults, lab reports, and invoices in one place.',
    F4_ICON: 'folder_shared',
    F5_TITLE: 'Invoices that flow',
    F5_BODY:
      'Generate invoices straight from the consultation. Track paid, pending, and overdue without a separate tool.',
    F5_ICON: 'receipt_long',
    F6_TITLE: 'Built for trust',
    F6_BODY:
      'Bank-grade auth, encrypted storage, role-based access, and full audit trails. Your data stays yours.',
    F6_ICON: 'verified_user',
  },
  HOW_IT_WORKS: {
    EYEBROW: 'How it works',
    HEADLINE: 'From sign-up to first prescription in under 5 minutes.',
    STEP_1_NUMBER: '01',
    STEP_1_TITLE: 'Create your account',
    STEP_1_BODY:
      'Sign up with email or Google. Add your specialization and license number. That\u2019s it.',
    STEP_2_NUMBER: '02',
    STEP_2_TITLE: 'Add your patients',
    STEP_2_BODY:
      'Bring patients in one by one or import in bulk. We\u2019ll match duplicates and build a clean history.',
    STEP_3_NUMBER: '03',
    STEP_3_TITLE: 'See patients, faster',
    STEP_3_BODY:
      'Run consultations in the cockpit, push prescriptions instantly, generate invoices in a click.',
  },
  FOR_DOCTORS: {
    EYEBROW: 'For doctors',
    HEADLINE: 'Designed with doctors. Pricing that respects them.',
    SUBHEADLINE:
      'We don\u2019t charge per patient. We don\u2019t lock your data. We don\u2019t pretend a CRM is a clinic OS.',
    POINT_1_TITLE: 'No per-patient fees',
    POINT_1_BODY: 'One flat plan. Add as many patients as you need.',
    POINT_2_TITLE: 'Your data, exportable',
    POINT_2_BODY: 'Export every patient, consult, and invoice anytime in JSON or CSV.',
    POINT_3_TITLE: 'Works on any device',
    POINT_3_BODY: 'Optimized for desktop in the clinic, fully usable on tablet and phone.',
    POINT_4_TITLE: 'Built in India, for India',
    POINT_4_BODY: 'INR billing, local time zones, designed for OPD-style workflows.',
  },
  TECH: {
    EYEBROW: 'Built for scale',
    HEADLINE: 'Modern stack. Cloud-native. Production-ready from day one.',
    SUBHEADLINE:
      'DocX runs on the same infrastructure that powers global SaaS — so we can scale with your practice without rewriting the foundations.',
    ITEMS: {
      FRONTEND: 'React 19 + TypeScript',
      BACKEND: 'Node.js + Express + Firestore',
      AUTH: 'JWT + Google OAuth',
      HOSTING: 'Firebase Hosting + Google Cloud Run',
      DATABASE: 'Cloud Firestore (Native mode)',
      DESIGN: 'Strict design system + dark mode',
    },
  },
  CTA_BANNER: {
    HEADLINE: 'Ready to make your clinic feel modern?',
    SUBHEADLINE:
      'Join the first cohort of doctors moving their practice onto DocX. Free to start, free to leave.',
    PRIMARY_CTA: 'Create your free account',
    SECONDARY_CTA: 'Talk to the team',
  },
  FOOTER: {
    TAGLINE: 'The everyday OS for doctors.',
    COL_PRODUCT: 'Product',
    COL_COMPANY: 'Company',
    COL_RESOURCES: 'Resources',
    LINK_FEATURES: 'Features',
    LINK_PRICING: 'Pricing',
    LINK_ROADMAP: 'Roadmap',
    LINK_ABOUT: 'About',
    LINK_CONTACT: 'Contact',
    LINK_CAREERS: 'Careers',
    LINK_DOCS: 'Docs',
    LINK_STATUS: 'Status',
    LINK_PRIVACY: 'Privacy',
    LINK_TERMS: 'Terms',
    CONTACT_EMAIL: 'hello@docx.co.in',
    LOCATION: 'Made in India',
    COPYRIGHT: '© 2026 DocX. All rights reserved.',
  },
  ARIA: {
    GO_TO_HOME: 'Go to DocX home',
    BACK_TO_HOME: 'Back to home',
  },
} as const;
